import { render } from "./SkinSelect.vue?vue&type=template&id=41db3252"
import script from "./SkinSelect.vue?vue&type=script&lang=js"
export * from "./SkinSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__